export const SET_CURRENCY_CODES_LOADED = "SET_CURRENCY_CODES_LOADED";

export const setCurrencyCodesLoaded = (currencyCodesLoaded: boolean) => {
  return {
    currencyCodesLoaded,
    type: SET_CURRENCY_CODES_LOADED
  };
};
